export const enum PurchaseOrderShipmentStatus {

    WAITING_FOR_PAYMENT = 'waiting_for_payment',
    WAITING_FOR_SHIPMENT_SENT = 'waiting_for_shipment_sent',
    WAITING_FOR_SHIPMENT_RECEIVED = 'waiting_for_shipment_received',
    SHIPMENT_RECEIVED = 'shipment_received',

}
